export function escapeRegExp(string) {
    return string.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&'); // $& means the whole matched string
}
//# sourceMappingURL=escapeRegExp.js.map